var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6916 20.6097C17.1216 20.6097 16.5616 20.4597 16.0416 20.1597L7.75156 15.3797C6.72156 14.7797 6.10156 13.7097 6.10156 12.5197C6.10156 11.3297 6.72156 10.2597 7.75156 9.65972L16.0416 4.87969C17.0716 4.27969 18.3016 4.27969 19.3416 4.87969C20.3816 5.47969 20.9915 6.5397 20.9915 7.7397V17.3097C20.9915 18.4997 20.3716 19.5697 19.3416 20.1697C18.8216 20.4597 18.2616 20.6097 17.6916 20.6097ZM17.6916 5.92971C17.3816 5.92971 17.0716 6.0097 16.7916 6.1697L8.50156 10.9497C7.94156 11.2797 7.60156 11.8597 7.60156 12.5097C7.60156 13.1597 7.94156 13.7397 8.50156 14.0697L16.7916 18.8497C17.3516 19.1797 18.0316 19.1797 18.5916 18.8497C19.1516 18.5197 19.4915 17.9397 19.4915 17.2897V7.71971C19.4915 7.06971 19.1516 6.48972 18.5916 6.15972C18.3116 6.01972 18.0016 5.92971 17.6916 5.92971Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75781 19.4537C3.34781 19.4537 3.00781 19.1137 3.00781 18.7037V6.34375C3.00781 5.93375 3.34781 5.59375 3.75781 5.59375C4.16781 5.59375 4.50781 5.93375 4.50781 6.34375V18.7037C4.50781 19.1137 4.16781 19.4537 3.75781 19.4537Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.a53cf779e277f78bdd77c5df1de4efa6.svg";
export { ForwardRef as ReactComponent };